import { useState, useEffect } from "react";

import styles from './navBar.module.css';
import StickyContainer from "components/StickyContainer";

const NavItems = (props) => {
  const scroll = (to) => {
    const element = document.getElementById(to);
    const headerOffset = 100;
    const elementPosition = element?.getBoundingClientRect().top;
    if (elementPosition) {
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
  return (
    <ul>
      {props.sections.map((section) => {
        if (section.menu_link) {
          return (
            <li key={`${props.type}-${section.type}`} style={props.style}>
              <button onClick={(e) => {
                props.closeMenu()
                scroll(section.type)
              }}
              style={{color: props.themeFormat.primaryText }}
              >
                {section.menu_link}
              </button>
            </li>
          )
        }
      })}
    </ul>
  )
};

const NavBar = (props) => {
  const [windowWidth, updateWindowWidth] = useState(0);


  const updateWindow = () => {
    updateWindowWidth(window.innerWidth);
  };

  const closeMenu = (e) => {
    if (props.menuVisible) {
      props.closeMenu();
    }
  };

  useEffect(() => {
    updateWindow();
    window.addEventListener("resize", updateWindow);

    return () => {
      window.removeEventListener("resize", updateWindow);
    };
  });



  if (windowWidth >= 968)
    return (
      <StickyContainer offsetFromTop={70}>
        <section style={{backgroundColor: props.themeFormat.primary, color: props.themeFormat.primaryText} }>
          <div className={styles.Container}>
            <NavItems themeFormat={props.themeFormat} style={{borderLeft: `1px solid ${props.themeFormat.primaryText}` }} sections={props.sections} closeMenu={closeMenu} place={props.place} type="desktop" />
          </div>
        </section>
      </StickyContainer>
    );

  return (
    <>
      <div
        className={styles.Overlay}
        style={{
          display: props.menuVisible ? "block" : "none",
        }}
        onClick={(e) => {
          props.closeMenu();
        }}
      />
      <section
        id="cr-BID-menu"
        className={!props.menuVisible ? `${styles.SideMenu} ${styles.displayNone}` : `${styles.SideMenu}`}
      >
        <NavItems themeFormat={props.themeFormat} style={{borderTop: `1px solid ${props.themeFormat.primaryText}` }} sections={props.sections} place={props.place} closeMenu={closeMenu} type="mobile" />
      </section>
    </>
  );
};

export default NavBar;
